<template>
  <v-main class="pa-0">
    <v-list-item>
      <v-list-item-content class="pa-2">
        <v-img src="@/assets/Prysmian-logo-extended.png" alt="Prysmian-logos" height="auto" />
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mx-1 mb-3" />

    <v-list nav v-if="userRole==='Provider'">
      <v-list-item active-class="primary white--text" to="/provider">
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>
      <v-divider class="mx-3 mb-3" />
      <v-list-item active-class="primary white--text" to="/exchange">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Exchange Storage</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="primary white--text" to="/provider-treeview">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Provider Storages</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list nav v-if="userRole === 'Operator' || userRole === 'Admin'">
      <div />
      <v-list-item active-class="primary white--text" to="/admin">
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <v-divider class="mx-3 mb-3" />

      <v-list-item active-class="primary white--text" to="/operator-storage">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Operator Storage</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="primary white--text" to="/provider-storage">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Provider Storages</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="primary white--text" to="/exchange-storage">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Exchange Storage</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="primary white--text" to="/batch-requests">
        <v-list-item-action>
          <v-icon>mdi-clipboard-list</v-icon>
        </v-list-item-action>
        <v-list-item-title>Batch Requests</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list nav v-if="userRole==='Admin'">
      <div />
      <v-divider class="mx-3 mb-3" />

      <v-list-item active-class="primary white--text" to="/admin-customers">
        <v-list-item-action>
          <v-icon>mdi-account-group</v-icon>
        </v-list-item-action>
        <v-list-item-title>Customers</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="primary white--text" to="/admin-providers">
        <v-list-item-action>
          <v-icon>mdi-switch</v-icon>
        </v-list-item-action>
        <v-list-item-title>Providers</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list nav v-if="userRole==='Customer'">
      <v-list-item active-class="primary white--text" to="/customer">
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>
      <v-divider class="mx-3 mb-3" />
      <v-list-item active-class="primary white--text" to="/customer-treeview">
        <v-list-item-action>
          <v-icon>mdi-file-tree</v-icon>
        </v-list-item-action>
        <v-list-item-title>Customer Storages</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-main>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["userRole"]),
};
</script>
